"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var moment_1 = __importDefault(require("moment"));
var __1 = require("../");
var styles = __importStar(require("./TodaysDateSignature.module.css"));
var react_1 = require("react");
var TodaysDateSignature = (function (_super) {
    __extends(TodaysDateSignature, _super);
    function TodaysDateSignature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TodaysDateSignature.prototype.render = function () {
        if (this.props.signature) {
            if (!this.props.json_data[this.props.id]) {
                this.props.json_data[this.props.id] = moment_1.default(new Date()).local().format("MM/DD/YYYY");
                this.props.onChange(this.props.id, this.props.json_data[this.props.id]);
            }
        }
        if (this.props.json_data[this.props.id]) {
            var isUtc = moment_1.default(this.props.json_data[this.props.id], "YYYY-MM-DDTHH:mm:ss[Z]", true).isValid();
            if (isUtc) {
                this.props.json_data[this.props.id] = moment_1.default(new Date()).local().format("MM/DD/YYYY");
                this.props.onChange(this.props.id, this.props.json_data[this.props.id]);
            }
        }
        return React.createElement(__1.Input, __assign({ classNameWrap: styles.root }, this.props));
    };
    return TodaysDateSignature;
}(react_1.Component));
exports.TodaysDateSignature = TodaysDateSignature;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVG9kYXlzRGF0ZVNpZ25hdHVyZS5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2NvbXBvbmVudHMvVG9kYXlzRGF0ZVNpZ25hdHVyZS9Ub2RheXNEYXRlU2lnbmF0dXJlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSwyQ0FBOEI7QUFDOUIsa0RBQTJCO0FBRTNCLHlCQUF5QjtBQUN6Qix1RUFBMEQ7QUFDMUQsK0JBQStCO0FBYS9CO0lBQXlDLHVDQUFvQjtJQUE3RDs7SUFrQkEsQ0FBQztJQWpCRyxvQ0FBTSxHQUFOO1FBQ0ksSUFBSSxJQUFJLENBQUMsS0FBSyxDQUFDLFNBQVMsRUFBRTtZQUN0QixJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUMsRUFBRTtnQkFDdEMsSUFBSSxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUMsR0FBRyxnQkFBTSxDQUFDLElBQUksSUFBSSxFQUFFLENBQUMsQ0FBQyxLQUFLLEVBQUUsQ0FBQyxNQUFNLENBQUMsWUFBWSxDQUFDLENBQUE7Z0JBQ3JGLElBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsRUFBRSxFQUFFLElBQUksQ0FBQyxLQUFLLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQTthQUMxRTtTQUNKO1FBQ0QsSUFBSSxJQUFJLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQyxFQUFFO1lBQ3JDLElBQU0sS0FBSyxHQUFHLGdCQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUMsRUFBRSx3QkFBd0IsRUFBRSxJQUFJLENBQUMsQ0FBQyxPQUFPLEVBQUUsQ0FBQTtZQUNuRyxJQUFJLEtBQUssRUFBRTtnQkFDUCxJQUFJLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQyxHQUFHLGdCQUFNLENBQUMsSUFBSSxJQUFJLEVBQUUsQ0FBQyxDQUFDLEtBQUssRUFBRSxDQUFDLE1BQU0sQ0FBQyxZQUFZLENBQUMsQ0FBQTtnQkFDckYsSUFBSSxDQUFDLEtBQUssQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxFQUFFLEVBQUUsSUFBSSxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFBO2FBQzFFO1NBQ0o7UUFFRCxPQUFPLG9CQUFDLFNBQUssYUFBQyxhQUFhLEVBQUUsTUFBTSxDQUFDLElBQUksSUFBTSxJQUFJLENBQUMsS0FBSyxFQUFJLENBQUE7SUFDaEUsQ0FBQztJQUNMLDBCQUFDO0FBQUQsQ0FBQyxBQWxCRCxDQUF5QyxpQkFBUyxHQWtCakQ7QUFsQlksa0RBQW1CIn0=